var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoResultTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "90px",
    height: "75.22px",
    viewBox: "0 0 90 75.22",
    style: {
      enableBackground: "new 0 0 90 75.22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;stroke:#1C4EC1;stroke-width:2;}\r\n\t.st2{fill:#1C4EC1;stroke:#1C4EC1;}\r\n\t.st3{fill:#1C4EC1;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_276",
    transform: "translate(-278 -1255.117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6955\\u5186\\u5F62_32",
    transform: "translate(278 1255.117)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 37.61,
    cy: 37.61,
    r: 37.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 37.61,
    cy: 37.61,
    r: 36.61
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u6955\\u5186\\u5F62_5",
    transform: "translate(331.731 1255.117)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 18.13,
    cy: 18.13,
    r: 18.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 18.13,
    cy: 18.13,
    r: 17.13
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_15",
    className: "st2",
    d: "M357.38,1282.32l-6.23-6.23c-0.51,0.41-1.09,0.72-1.71,0.94c-0.66,0.23-1.35,0.35-2.05,0.35 c-1.71,0.03-3.36-0.64-4.56-1.86c-1.22-1.2-1.9-2.85-1.86-4.56c-0.03-1.71,0.64-3.36,1.86-4.56c1.2-1.22,2.85-1.9,4.56-1.86 c1.71-0.03,3.36,0.64,4.56,1.86c1.22,1.2,1.9,2.85,1.86,4.56c0,0.7-0.11,1.39-0.35,2.05c-0.22,0.62-0.53,1.19-0.94,1.71l6.23,6.23 L357.38,1282.32z M347.39,1275.4c1.19,0.02,2.33-0.45,3.15-1.3c0.85-0.83,1.32-1.97,1.3-3.15c0.02-1.18-0.45-2.33-1.3-3.15 c-0.83-0.85-1.97-1.32-3.15-1.3c-1.19-0.02-2.33,0.45-3.16,1.3c-0.85,0.83-1.32,1.97-1.29,3.16c-0.02,1.18,0.45,2.32,1.29,3.15 C345.07,1274.95,346.21,1275.42,347.39,1275.4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_512",
    x: 296.81,
    y: 1280.64,
    className: "st3",
    width: 4.03,
    height: 4.03
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_513",
    x: 304.87,
    y: 1280.64,
    className: "st3",
    width: 21.49,
    height: 4.03
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_514",
    x: 296.81,
    y: 1290.04,
    className: "st3",
    width: 4.03,
    height: 4.03
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_515",
    x: 304.87,
    y: 1290.04,
    className: "st3",
    width: 28.21,
    height: 4.03
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_516",
    x: 296.81,
    y: 1299.45,
    className: "st3",
    width: 4.03,
    height: 4.03
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_517",
    x: 304.87,
    y: 1299.45,
    className: "st3",
    width: 28.21,
    height: 4.03
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoResultTitle);
export default __webpack_public_path__ + "static/media/ico_result_title.67429a0eab5036ed3ee9c8bf2eb3bebe.svg";
export { ForwardRef as ReactComponent };